import { useState, useCallback, useEffect } from 'react';
import { fireErrorAnalytics } from '@atlassian/jira-errors-handling';
import { performGetRequest } from '@atlassian/jira-fetch';

export const useGetSpaceKey = (projectName: string, coUseEligible: boolean): string => {
	const [spaceKey, setSpaceKey] = useState('');

	const checkForConfluenceSpace = useCallback(async () => {
		if (coUseEligible) {
			try {
				const cql = `type = space and title = "${projectName}"`;
				const api = `/wiki/rest/api/search?cql=${cql}`;
				const res = await performGetRequest(api);
				if (res.results?.length) {
					setSpaceKey(res.results[0].space.key);
				}
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				fireErrorAnalytics({
					meta: {
						id: 'GetSpaceKey',
						packageName: 'jiraSoftwareBacklog',
					},
					error,
				});
				setSpaceKey('');
			}
		}
	}, [coUseEligible, projectName]);

	useEffect(() => {
		checkForConfluenceSpace();
	}, [checkForConfluenceSpace]);

	return spaceKey;
};
